import React from 'react';
import { Button, Icon, Toast } from '@roo/roo';
import PropType from 'prop-types';
import { useSimpleContext } from '../_context';

export function Plus(props) {
  const {
    handlePush, maxCount, count, text, tip,
  } = props;
  const {
    state: { disabled },
  } = useSimpleContext((t) => [t.disabled]);

  if (disabled) {
    return <div className="form-plus" />;
  }
  return (
    <div className="form-plus" style={{ visibility: count >= maxCount ? 'hidden' : undefined }}>
      <Button
        type="text"
        onClick={() => {
          if (disabled) {
            return;
          }
          if (count >= maxCount) {
            Toast.open({ title: tip || `最多添加${maxCount}个` });
          } else {
            handlePush();
          }
        }}
      >
        <Icon name="plus" />
        {' '}
        {text}
      </Button>
      {props.children}
    </div>
  );
}

Plus.propTypes = {
  maxCount: PropType.number.isRequired,
  handlePush: PropType.func.isRequired,
  text: PropType.string.isRequired,
  count: PropType.number.isRequired,
};
